module.exports = __webpack_public_path__ + "static/img/tutorial-normal-attraction-1.667ca2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-normal-attraction-1.jpg
// module id = 27GY
// module chunks = 3